import axios from "../axiosConfig"; // Adjust the import path accordingly

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const BillType = {

  GetBillType: async () => {
    try {
      //const apiUrl = `${express_server_url}/api/BillType/GetBillTypes`;
      const apiUrl = `${WebApiUrl}/api/BillType/GetBillTypes`;
      const response = await axios.post(
        apiUrl,
        {},
        {
          withCredentials: true,
        }
      );
      // console.log(apiUrl);
      console.log("Response:", response.data.result);
      return response.data.result;
      // setMainDataCallback(response.data.result);
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  insertBillType: async (data) => {
    try {
      //const apiUrl = `${express_server_url}/api/BillType/BillType`;
      const apiUrl = `${WebApiUrl}/api/BillType/BillType`;
      console.log(apiUrl);
      console.log(data);
      const response = await axios.post(apiUrl, {
        id: Number(data.id) || 0,
        billType: Number(data.billType) || 0,
        billTypeName: data.billTypeName || 0,
        specifyAccInfo_Sale: Number(data.specifyAccInfo_Sale) || 0,
        accForGoods: Number(data.accForGoods) || 0,
        accForService: Number(data.accForService) || 0,
        typeOfTax: Number(data.typeOfTax) || 0,
        taxOn: Number(data.taxOn) || 0,
        modeOfTax: data.modeOfTax  || "",
        calculatTaxOn: Number(data.calculatTaxOn) || 0,
        adjTaxInSale: Boolean(data.adjTaxInSale) || false,
        tCgstAcc: String(data.tCgstAcc)  || "",
        tSgstAcc: String(data.tSgstAcc)  || "",
        tIgstAcc: String(data.tIgstAcc)  || "",
        tCesstAcc: String(data.tCesstAcc) || "",
        taxRegion: Number(data.taxRegion) || 0,
        sundryDiscDistri: Boolean(data.sundryDiscDistri) || false,
        transactionType: data.transactionType ||  "",
        taxRateType: Number(data.taxRateType) || 0,
        cgsTper: Number(data.cgsTper) || 0,
        sgsTper: Number(data.sgsTper) || 0,
        igsTper: Number(data.igsTper) || 0,
        cesSper: Number(data.cesSper) || 0,
        isDefault: Boolean(data.isDefault) || true,
        isActive: Boolean(data.isActive) || true,
      }, {
        withCredentials: true,
        credentials: 'include',
      });
      console.log("Response:", response.data);
      return true;
    } catch (error) {
      console.error("Error:", error.message);
      if (error.response && error.response.status === 401) {
        alert("Failed");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  },

  GetBillTypeById: async (BillTypeId) => {
    try {
      console.log("get by id");
      //const apiUrl = `${express_server_url}/api/BillType?BillTypeId=${BillTypeId}`;
      const apiUrl = `${WebApiUrl}/api/BillType?BillTypeId=${BillTypeId}`;
      const response = await axios.get(
        apiUrl,
        {},
        {
          withCredentials: true,
        }
      );
      console.log("Response:", response.data.result);
      return response.data.result;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  // *********************** Filtered **************************
  GetFilteredBillType: async (filterData) => {
    const filteredData = filterData.map(data => ({
      fieldName: data.fieldName,
      operatorName: data.operatorName,
      compareValue: data.compareValue
    }));
    try {
      const apiUrl = `${WebApiUrl}/api/BillType/GetBillTypes`;
      const response = await axios.post(apiUrl, {
        filter: filteredData,
        order: [
          {
            propertyName: "string",
            ascending: true
          }
        ],
        pageNumber: 0,
        pageSize: 0
      }, {
        withCredentials: true,
      });
      console.log('Response:', response.data.result);
      return response.data.result;

    } catch (error) {
      console.error('Error:', error.message);
    }
  },


  // // ************************* Get By Id ****************************
  // GetAgentById: async (id) => {
  //   try {
  //     const apiUrl = `${express_server_url}/api/Agent?agentId=${id}`;
  //     const response = await axios.get(apiUrl, {}, {
  //       withCredentials: true,
  //     });
  //     console.log('Response:', response.data.result);
  //     //setEditCallBack(response.data.result);
  //    return response.data.result;
  //   } catch (error) {
  //     console.error('Error:', error.message);
  //   }
  // },

  deleteBillType: async (BillTypeId) => {
    try {
      console.log("delete");
      //const apiUrl = `${express_server_url}/api/BillType?BillTypeId=${BillTypeId}`;
      const apiUrl = `${WebApiUrl}/api/BillType?BillTypeId=${BillTypeId}`;
      const response = await axios.delete(apiUrl, {
        withCredentials: true,
      });
      console.log("Delete Response:", response.data.result);
      return true;
    } catch (error) {
      console.error("Error:", error.message);
    }
  },

  updateBillType: async (data) => {
    console.log(data);
    
    try {
      //const apiUrl = `${express_server_url}/api/BillType?BillTypeId=${data.id}`;
      const apiUrl = `${WebApiUrl}/api/BillType?BillTypeId=${data.id}`;
      const response = await axios.put(apiUrl, {
        id: Number(data.id),
        billType: Number(data.billType) || 0,
        billTypeName: data.billTypeName || 0,
        specifyAccInfo_Sale: Number(data.specifyAccInfo_Sale) || 0,
        accForGoods: Number(data.accForGoods) || 0,
        accForService: Number(data.accForService) || 0,
        typeOfTax: Number(data.typeOfTax) || 0,
        taxOn: Number(data.taxOn) || 0,
        modeOfTax: data.modeOfTax  || "",
        calculatTaxOn: Number(data.calculatTaxOn) || 0,
        adjTaxInSale: Boolean(data.adjTaxInSale) || false,
        tCgstAcc: String(data.tCgstAcc)  || "",
        tSgstAcc: String(data.tSgstAcc)  || "",
        tIgstAcc: String(data.tIgstAcc)  || "",
        tCesstAcc: String(data.tCesstAcc) || "",
        taxRegion: Number(data.taxRegion) || 0,
        sundryDiscDistri: Boolean(data.sundryDiscDistri) || false,
        transactionType: data.transactionType ||  "",
        taxRateType: Number(data.taxRateType) || 0,
        cgsTper: Number(data.cgsTper) || 0,
        sgsTper: Number(data.sgsTper) || 0,
        igsTper: Number(data.igsTper) || 0,
        cesSper: Number(data.cesSper) || 0,
        isDefault: Boolean(data.isDefault) || true,
        isActive: Boolean(data.isActive) || true,
      },
        {
          withCredentials: true,
          credentials: "include",
        }
      );
      return response.data.isSuccess

      // setMainDataCallback(response.data.result);
    } catch (error) {
      console.error("Error:", error.message);
    }
  },
};

export default BillType;
